// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p.url-but-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgb(43 48 59);
    text-shadow: black 0px -0.1em 0.2em;
    color: #fff;
    padding: 10px 5px;
    border: 0.3em solid rgb(122, 102, 82);
    border-radius: 0.5em;
    box-shadow: black 1px 1px 0.5em inset;
}

.url-but-box-1 {
    background: rgb(43 48 59);
    text-shadow: black 0px -0.1em 0.2em;
    color: #fff;
    padding: 10px 5px;
    border: 0.3em solid rgb(122, 102, 82);
    border-radius: 0.5em;
    box-shadow: black 1px 1px 0.5em inset;
}

button.but-api-url-method.btn.btn-primary {
    font-size: 14px;
    background-color: #5e7660;
    border: 0px;
}

span.url-span {
    font-size: 13px;
    font-weight: 400;
    margin-left: 6px;
}

p.url-show {
    color: #fff;
    font-size: 13px;
    word-break: break-all;
}

pre.box-code {
    font-weight: 400;
    font-size: 12px !important;
    border: 0px !important;
    box-shadow: none !important;
}

p.heading-code-box {
    padding: 10px 0px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
}

.bu-group {
    display: flex;
    align-items: center;
    justify-content: end;
}

.nav-tabs {
    border-bottom: 0px !important;
}

button#noanim-tab-example-tab-200 {
    color: green;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
}

.nav-tabs button.nav-link {
    border: 1px solid #0000009e;
    border-radius: 6px;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
}

.nav-tabs .nav-link.active {
    color: #000;
}

.code-box .nav-item {
    margin: 8px;
}

/* p.error-code-req {
    font-weight: 300;
    font-size: 12px;
    color: red;
} */

/* p.button-close.status-200 {
    border: 1px solid green;
    padding: 8px 8px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 400;
    color: green;
    cursor: pointer;
} */

/* .button-plus.status-200 {
    border: 1px solid green;
    padding: 8px 8px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 400;
    color: green;
    cursor: pointer;
} */

/* p.button-close.status-400 {
    border: 1px solid red;
    padding: 8px 8px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 400;
    color: red;
    cursor: pointer;
}

.button-plus.status-400 {
    border: 1px solid red;
    padding: 8px 8px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 400;
    color: red;
    cursor: pointer;
} */

p.json-formet {
    font-weight: 200;
    margin: 8px 10px;
    background: gray;
    padding: 6px 8px;
    font-size: 14px;
    border-radius: 4px;
}

select#selectField {
    background: #5e7660;
    color: #fff;
    font-weight: 300;
    font-size: 14px;
    border-radius: 6px;
    margin: 8px 0px;
    border: 0px;
    width: 100%;
    padding: 6px 8px;
}

.dropMenu {
    margin: 6px;
}

option.option-h {
    color: #000;
    background: #fff;
}

select:focus-visible {
    border: 0px solid transparent;
    border-radius: 0px;
    outline: none;
}

p.error-heading-pra {
    margin-top: 15px;
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: 600;
}

span.object-size {
    display: none !important;
}

.object-key-val {
    font-size: 13px;
    font-weight: 600;
    padding: 10px;
}

.auth-pera-box {
    box-shadow: black 1px 1px 0.5em inset;
    padding: 10px 14px;
    background-color: #2b303b;
    color: #fff;
    border-radius: 6px;
    margin-bottom: 10px;
    border: 0.3em solid rgb(122, 102, 82);
}

.img-box img {
    width: 100%;
}

.img-box-1 {
    text-align: center;
}

.img-box-1 img {
    width: 200px;
    height: 200px;
}

.react-json-view {
    overflow: overlay !important;
}

.react-json-view::-webkit-scrollbar {
    width: 2px;
    height: 6px;
}

.react-json-view::-webkit-scrollbar-track {
    background: transparent;
}

.react-json-view::-webkit-scrollbar-thumb {
    background: #d4d1d1;
    border-radius: 6px;
}

.p-pera strong {
    color: #2c2c2c;
    font-size: 15px;
    font-weight: 700;
}

.auth-box {
    /* border: 1px solid #d8dde7; */
    border-radius: 6px;
}

.code-box {
    background-color: #3e444f;
    padding: 10px 14px;
}

.keys-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

p.keys-name {
    border: 2px solid gray;
    padding: 6px 8px;
    font-size: 14px;
    font-weight: 400;
}

li.header-nav {
    font-size: 20px;
    font-weight: 500;
    list-style-type: none;
    margin: 0px 0px 0px 15px;
  }
  .download-postman-btn {
    background-color: #f26822;
    color: white;
    padding: 8px 14px;
    text-decoration: none;
    border-radius: 5px;
    font-weight: 500;
    font-size: 14px;
    transition: background-color 0.3s ease;
  }
  
  .download-postman-btn:hover {
    background-color: #d45718;
  }

@media (max-width: 430px) {
    .code-box .nav-item {
        margin: 5px;
    }

    button#noanim-tab-example-tab-200 {
        font-size: 12px;
        padding: 8px 12px;
    }

    .nav-tabs button.nav-link {
        font-size: 12px;
        padding: 8px 12px;
    }
}

@media (max-width: 514px) {
    .code-box .nav-item {
        margin: 10px;
    }

    button#noanim-tab-example-tab-200 {
        font-size: 12px;
        padding: 8px 12px;
    }

    .nav-tabs button.nav-link {
        font-size: 12px;
        padding: 8px 12px;
    }
}

@media (max-width: 575px) {
    p.error-heading-pra {
        font-size: 15px;
    }
}

@media (max-width: 767px) {
    select#selectField {
        width: 100%;
        margin: 0px;
    }
}
.tra-section {
    margin-top: 150px;
}

button.url-copy-b.btn.btn-outline-secondary.btn-sm {
    float: right;
    background: #5e7660;
    color: #fff;
    border-radius: 8px;
}
h5.h5-heading {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;
}


.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .url-copy-b svg {
    margin-bottom: 2px;
}

p.url-but-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgb(43 48 59);
    text-shadow: black 0px -0.1em 0.2em;
    color: #fff;
    padding: 10px 5px;
    border: 0.3em solid rgb(122, 102, 82);
    border-radius: 0.5em;
    box-shadow: black 1px 1px 0.5em inset;
}

.url-but-box-1 {
    background: rgb(43 48 59);
    text-shadow: black 0px -0.1em 0.2em;
    color: #fff;
    padding: 10px 5px;
    border: 0.3em solid rgb(122, 102, 82);
    border-radius: 0.5em;
    box-shadow: black 1px 1px 0.5em inset;
}

button.but-api-url-method.btn.btn-primary {
    font-size: 14px;
    background-color: #5e7660;
    border: 0px;
}

span.url-span {
    font-size: 13px;
    font-weight: 400;
    margin-left: 6px;
}

p.url-show {
    margin-bottom: 0px;
    color: #000;
    font-size: 11px;
    word-break: break-all;
}
pre.box-code {
    font-weight: 400;
    font-size: 12px !important;
    border: 0px !important;
    box-shadow: none !important;
}

p.heading-code-box {
    padding: 10px 0px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
}

.bu-group {
    display: flex;
    align-items: center;
    justify-content: end;
}

.nav-tabs {
    border-bottom: 0px !important;
    margin-bottom: 15px;
}
button#noanim-tab-example-tab-200 {
    color: green;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
}

.nav-tabs button.nav-link {
    border: 1px solid #0000009e;
    border-radius: 6px;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
}

.nav-tabs .nav-link.active {
    color: #000;
}

.code-box .nav-item {
    margin: 8px;
}


p.json-formet {
    font-weight: 200;
    margin: 8px 10px;
    background: gray;
    padding: 6px 8px;
    font-size: 14px;
    border-radius: 4px;
}

select#selectField {
    background: #5e7660;
    color: #fff;
    font-weight: 300;
    font-size: 14px;
    border-radius: 6px;
    margin: 8px 0px;
    border: 0px;
    width: 100%;
    padding: 6px 8px;
}

.dropMenu {
    margin: 6px;
}

option.option-h {
    color: #000;
    background: #fff;
}

select:focus-visible {
    border: 0px solid transparent;
    border-radius: 0px;
    outline: none;
}


p.error-heading-pra {
    margin-top: 15px;
    font-size: 15px;
    font-weight: 600;
}

span.object-size {
    display: none !important;
}

.object-key-val {
    font-size: 13px;
    font-weight: 600;
    padding: 10px;
}

.auth-pera-box {
    box-shadow: black 1px 1px 0.5em inset;
    padding: 10px 14px;
    background-color: #2b303b;
    color: #fff;
    border-radius: 6px;
    margin-bottom: 10px;
    border: 0.3em solid rgb(122, 102, 82);
}

.img-box img {
    width: 100%;
}

.img-box-1 {
    text-align: center;
}

.img-box-1 img {
    width: 200px;
    height: 200px;
}

.react-json-view {
    overflow: overlay !important;
}

.react-json-view::-webkit-scrollbar {
    width: 2px;
    height: 6px;
}

.react-json-view::-webkit-scrollbar-track {
    background: transparent;
}

.react-json-view::-webkit-scrollbar-thumb {
    background: #d4d1d1;
    border-radius: 6px;
}


.auth-box {
    border-radius: 6px;
}

.code-box {
    background-color: #3e444f;
    padding: 10px 14px;
}

.keys-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

p.keys-name {
    border: 2px solid gray;
    padding: 6px 8px;
    font-size: 14px;
    font-weight: 400;
}

li.header-nav {
    font-size: 20px;
    font-weight: 500;
    list-style-type: none;
    margin: 0px 0px 0px 15px;
  }
  .download-postman-btn {
    background-color: #f26822;
    color: white;
    padding: 8px 14px;
    text-decoration: none;
    border-radius: 5px;
    font-weight: 500;
    font-size: 14px;
    transition: background-color 0.3s ease;
  }
  
  .download-postman-btn:hover {
    background-color: #d45718;
  }

@media (max-width: 430px) {
    .code-box .nav-item {
        margin: 5px;
    }

    button#noanim-tab-example-tab-200 {
        font-size: 12px;
        padding: 8px 12px;
    }

    .nav-tabs button.nav-link {
        font-size: 12px;
        padding: 8px 12px;
    }
}

@media (max-width: 514px) {
    .code-box .nav-item {
        margin: 10px;
    }

    button#noanim-tab-example-tab-200 {
        font-size: 12px;
        padding: 8px 12px;
    }

    .nav-tabs button.nav-link {
        font-size: 12px;
        padding: 8px 12px;
    }
}

@media (max-width: 575px) {
    p.error-heading-pra {
        font-size: 15px;
    }
}

@media (max-width: 767px) {
    select#selectField {
        width: 100%;
        margin: 0px;
    }
}
.tra-section {
    margin-top: 150px;
}

button.url-copy-b.btn.btn-outline-secondary.btn-sm {
    float: right;
    background: #5e7660;
    color: #fff;
    border-radius: 8px;
}
h5.h5-heading {
    font-size: 18px;
    font-weight: 600;
}


.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  

  















/* 

  .tab-btn-list {
    display: flex;
    gap: 10px;
    margin-bottom: 1rem;
  }
  
  .tab-btn {
    padding: 6px 16px;
    border-radius: 8px;
    background-color: #2d3748;
    color: #fff;
    border: 1px solid #4a5568;
    cursor: pointer;
    transition: 0.3s ease;
  }
  
  .tab-btn:hover {
    background-color: #4a5568;
  }
  
  .active-tab {
    background-color: #ffffff;
    color: #1a202c;
    font-weight: bold;
  }
  
  .tab-content-box {
    background-color: #1a202c;
    padding: 1rem;
    border-radius: 8px;
    margin-top: 1rem;
    color: #ffffff;
  }
  
  .select-box {
    background-color: #2d3748;
    border: 1px solid #4a5568;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    margin-bottom: 10px;
  }
   */


   .tab-box-outer.nav-link {
    border: 1px solid #fff !important;
    color: #fff !important;
  }
  .nav-tabs .nav-link:hover {
    color: #000 !important;
  }
  /* .nav-tabs .nav-link {
    border-radius: 6px !important;
  
} */


.nav-tabs .nav-link {
    color: white;
    background-color: transparent;
    border: none;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 6px !important;
    border: 1px solid #fff !important;


  }
  
  .nav-tabs .nav-link.active {
    background-color: white;
    color: black;
    border-radius: 5px;
  }
  


  .collapse-box {
    padding: 10px;
    border: 1px solid #ddd;
    background: #f9f9f9;
    margin-top: 10px;
    color: #000;
  }
  
  .coll-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`, "",{"version":3,"sources":["webpack://./src/assets/css/methods.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,mCAAmC;IACnC,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;;;GAIG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;;;;;;;;;;;;;;GAkBG;;AAEH;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,mCAAmC;IACnC,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;AACjB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;;;;;;;;;;;;;;;;;;AAmBF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4CI;;;GAGD;IACC,iCAAiC;IACjC,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;;;GAGC;;;AAGH;IACI,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,iCAAiC;;;EAGnC;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;EACpB;;;;EAIA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB","sourcesContent":["p.url-but-box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: rgb(43 48 59);\n    text-shadow: black 0px -0.1em 0.2em;\n    color: #fff;\n    padding: 10px 5px;\n    border: 0.3em solid rgb(122, 102, 82);\n    border-radius: 0.5em;\n    box-shadow: black 1px 1px 0.5em inset;\n}\n\n.url-but-box-1 {\n    background: rgb(43 48 59);\n    text-shadow: black 0px -0.1em 0.2em;\n    color: #fff;\n    padding: 10px 5px;\n    border: 0.3em solid rgb(122, 102, 82);\n    border-radius: 0.5em;\n    box-shadow: black 1px 1px 0.5em inset;\n}\n\nbutton.but-api-url-method.btn.btn-primary {\n    font-size: 14px;\n    background-color: #5e7660;\n    border: 0px;\n}\n\nspan.url-span {\n    font-size: 13px;\n    font-weight: 400;\n    margin-left: 6px;\n}\n\np.url-show {\n    color: #fff;\n    font-size: 13px;\n    word-break: break-all;\n}\n\npre.box-code {\n    font-weight: 400;\n    font-size: 12px !important;\n    border: 0px !important;\n    box-shadow: none !important;\n}\n\np.heading-code-box {\n    padding: 10px 0px;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.bu-group {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n}\n\n.nav-tabs {\n    border-bottom: 0px !important;\n}\n\nbutton#noanim-tab-example-tab-200 {\n    color: green;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.nav-tabs button.nav-link {\n    border: 1px solid #0000009e;\n    border-radius: 6px;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.nav-tabs .nav-link.active {\n    color: #000;\n}\n\n.code-box .nav-item {\n    margin: 8px;\n}\n\n/* p.error-code-req {\n    font-weight: 300;\n    font-size: 12px;\n    color: red;\n} */\n\n/* p.button-close.status-200 {\n    border: 1px solid green;\n    padding: 8px 8px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 400;\n    color: green;\n    cursor: pointer;\n} */\n\n/* .button-plus.status-200 {\n    border: 1px solid green;\n    padding: 8px 8px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 400;\n    color: green;\n    cursor: pointer;\n} */\n\n/* p.button-close.status-400 {\n    border: 1px solid red;\n    padding: 8px 8px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 400;\n    color: red;\n    cursor: pointer;\n}\n\n.button-plus.status-400 {\n    border: 1px solid red;\n    padding: 8px 8px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 400;\n    color: red;\n    cursor: pointer;\n} */\n\np.json-formet {\n    font-weight: 200;\n    margin: 8px 10px;\n    background: gray;\n    padding: 6px 8px;\n    font-size: 14px;\n    border-radius: 4px;\n}\n\nselect#selectField {\n    background: #5e7660;\n    color: #fff;\n    font-weight: 300;\n    font-size: 14px;\n    border-radius: 6px;\n    margin: 8px 0px;\n    border: 0px;\n    width: 100%;\n    padding: 6px 8px;\n}\n\n.dropMenu {\n    margin: 6px;\n}\n\noption.option-h {\n    color: #000;\n    background: #fff;\n}\n\nselect:focus-visible {\n    border: 0px solid transparent;\n    border-radius: 0px;\n    outline: none;\n}\n\np.error-heading-pra {\n    margin-top: 15px;\n    margin-bottom: 12px;\n    font-size: 15px;\n    font-weight: 600;\n}\n\nspan.object-size {\n    display: none !important;\n}\n\n.object-key-val {\n    font-size: 13px;\n    font-weight: 600;\n    padding: 10px;\n}\n\n.auth-pera-box {\n    box-shadow: black 1px 1px 0.5em inset;\n    padding: 10px 14px;\n    background-color: #2b303b;\n    color: #fff;\n    border-radius: 6px;\n    margin-bottom: 10px;\n    border: 0.3em solid rgb(122, 102, 82);\n}\n\n.img-box img {\n    width: 100%;\n}\n\n.img-box-1 {\n    text-align: center;\n}\n\n.img-box-1 img {\n    width: 200px;\n    height: 200px;\n}\n\n.react-json-view {\n    overflow: overlay !important;\n}\n\n.react-json-view::-webkit-scrollbar {\n    width: 2px;\n    height: 6px;\n}\n\n.react-json-view::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.react-json-view::-webkit-scrollbar-thumb {\n    background: #d4d1d1;\n    border-radius: 6px;\n}\n\n.p-pera strong {\n    color: #2c2c2c;\n    font-size: 15px;\n    font-weight: 700;\n}\n\n.auth-box {\n    /* border: 1px solid #d8dde7; */\n    border-radius: 6px;\n}\n\n.code-box {\n    background-color: #3e444f;\n    padding: 10px 14px;\n}\n\n.keys-box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\np.keys-name {\n    border: 2px solid gray;\n    padding: 6px 8px;\n    font-size: 14px;\n    font-weight: 400;\n}\n\nli.header-nav {\n    font-size: 20px;\n    font-weight: 500;\n    list-style-type: none;\n    margin: 0px 0px 0px 15px;\n  }\n  .download-postman-btn {\n    background-color: #f26822;\n    color: white;\n    padding: 8px 14px;\n    text-decoration: none;\n    border-radius: 5px;\n    font-weight: 500;\n    font-size: 14px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .download-postman-btn:hover {\n    background-color: #d45718;\n  }\n\n@media (max-width: 430px) {\n    .code-box .nav-item {\n        margin: 5px;\n    }\n\n    button#noanim-tab-example-tab-200 {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n\n    .nav-tabs button.nav-link {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n}\n\n@media (max-width: 514px) {\n    .code-box .nav-item {\n        margin: 10px;\n    }\n\n    button#noanim-tab-example-tab-200 {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n\n    .nav-tabs button.nav-link {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n}\n\n@media (max-width: 575px) {\n    p.error-heading-pra {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 767px) {\n    select#selectField {\n        width: 100%;\n        margin: 0px;\n    }\n}\n.tra-section {\n    margin-top: 150px;\n}\n\nbutton.url-copy-b.btn.btn-outline-secondary.btn-sm {\n    float: right;\n    background: #5e7660;\n    color: #fff;\n    border-radius: 8px;\n}\nh5.h5-heading {\n    margin-top: 20px;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n\n.loader-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.8);\n    z-index: 9999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .url-copy-b svg {\n    margin-bottom: 2px;\n}\n\np.url-but-box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: rgb(43 48 59);\n    text-shadow: black 0px -0.1em 0.2em;\n    color: #fff;\n    padding: 10px 5px;\n    border: 0.3em solid rgb(122, 102, 82);\n    border-radius: 0.5em;\n    box-shadow: black 1px 1px 0.5em inset;\n}\n\n.url-but-box-1 {\n    background: rgb(43 48 59);\n    text-shadow: black 0px -0.1em 0.2em;\n    color: #fff;\n    padding: 10px 5px;\n    border: 0.3em solid rgb(122, 102, 82);\n    border-radius: 0.5em;\n    box-shadow: black 1px 1px 0.5em inset;\n}\n\nbutton.but-api-url-method.btn.btn-primary {\n    font-size: 14px;\n    background-color: #5e7660;\n    border: 0px;\n}\n\nspan.url-span {\n    font-size: 13px;\n    font-weight: 400;\n    margin-left: 6px;\n}\n\np.url-show {\n    margin-bottom: 0px;\n    color: #000;\n    font-size: 11px;\n    word-break: break-all;\n}\npre.box-code {\n    font-weight: 400;\n    font-size: 12px !important;\n    border: 0px !important;\n    box-shadow: none !important;\n}\n\np.heading-code-box {\n    padding: 10px 0px;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.bu-group {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n}\n\n.nav-tabs {\n    border-bottom: 0px !important;\n    margin-bottom: 15px;\n}\nbutton#noanim-tab-example-tab-200 {\n    color: green;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.nav-tabs button.nav-link {\n    border: 1px solid #0000009e;\n    border-radius: 6px;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.nav-tabs .nav-link.active {\n    color: #000;\n}\n\n.code-box .nav-item {\n    margin: 8px;\n}\n\n\np.json-formet {\n    font-weight: 200;\n    margin: 8px 10px;\n    background: gray;\n    padding: 6px 8px;\n    font-size: 14px;\n    border-radius: 4px;\n}\n\nselect#selectField {\n    background: #5e7660;\n    color: #fff;\n    font-weight: 300;\n    font-size: 14px;\n    border-radius: 6px;\n    margin: 8px 0px;\n    border: 0px;\n    width: 100%;\n    padding: 6px 8px;\n}\n\n.dropMenu {\n    margin: 6px;\n}\n\noption.option-h {\n    color: #000;\n    background: #fff;\n}\n\nselect:focus-visible {\n    border: 0px solid transparent;\n    border-radius: 0px;\n    outline: none;\n}\n\n\np.error-heading-pra {\n    margin-top: 15px;\n    font-size: 15px;\n    font-weight: 600;\n}\n\nspan.object-size {\n    display: none !important;\n}\n\n.object-key-val {\n    font-size: 13px;\n    font-weight: 600;\n    padding: 10px;\n}\n\n.auth-pera-box {\n    box-shadow: black 1px 1px 0.5em inset;\n    padding: 10px 14px;\n    background-color: #2b303b;\n    color: #fff;\n    border-radius: 6px;\n    margin-bottom: 10px;\n    border: 0.3em solid rgb(122, 102, 82);\n}\n\n.img-box img {\n    width: 100%;\n}\n\n.img-box-1 {\n    text-align: center;\n}\n\n.img-box-1 img {\n    width: 200px;\n    height: 200px;\n}\n\n.react-json-view {\n    overflow: overlay !important;\n}\n\n.react-json-view::-webkit-scrollbar {\n    width: 2px;\n    height: 6px;\n}\n\n.react-json-view::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.react-json-view::-webkit-scrollbar-thumb {\n    background: #d4d1d1;\n    border-radius: 6px;\n}\n\n\n.auth-box {\n    border-radius: 6px;\n}\n\n.code-box {\n    background-color: #3e444f;\n    padding: 10px 14px;\n}\n\n.keys-box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\np.keys-name {\n    border: 2px solid gray;\n    padding: 6px 8px;\n    font-size: 14px;\n    font-weight: 400;\n}\n\nli.header-nav {\n    font-size: 20px;\n    font-weight: 500;\n    list-style-type: none;\n    margin: 0px 0px 0px 15px;\n  }\n  .download-postman-btn {\n    background-color: #f26822;\n    color: white;\n    padding: 8px 14px;\n    text-decoration: none;\n    border-radius: 5px;\n    font-weight: 500;\n    font-size: 14px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .download-postman-btn:hover {\n    background-color: #d45718;\n  }\n\n@media (max-width: 430px) {\n    .code-box .nav-item {\n        margin: 5px;\n    }\n\n    button#noanim-tab-example-tab-200 {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n\n    .nav-tabs button.nav-link {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n}\n\n@media (max-width: 514px) {\n    .code-box .nav-item {\n        margin: 10px;\n    }\n\n    button#noanim-tab-example-tab-200 {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n\n    .nav-tabs button.nav-link {\n        font-size: 12px;\n        padding: 8px 12px;\n    }\n}\n\n@media (max-width: 575px) {\n    p.error-heading-pra {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 767px) {\n    select#selectField {\n        width: 100%;\n        margin: 0px;\n    }\n}\n.tra-section {\n    margin-top: 150px;\n}\n\nbutton.url-copy-b.btn.btn-outline-secondary.btn-sm {\n    float: right;\n    background: #5e7660;\n    color: #fff;\n    border-radius: 8px;\n}\nh5.h5-heading {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n\n.loader-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.8);\n    z-index: 9999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* \n\n  .tab-btn-list {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 1rem;\n  }\n  \n  .tab-btn {\n    padding: 6px 16px;\n    border-radius: 8px;\n    background-color: #2d3748;\n    color: #fff;\n    border: 1px solid #4a5568;\n    cursor: pointer;\n    transition: 0.3s ease;\n  }\n  \n  .tab-btn:hover {\n    background-color: #4a5568;\n  }\n  \n  .active-tab {\n    background-color: #ffffff;\n    color: #1a202c;\n    font-weight: bold;\n  }\n  \n  .tab-content-box {\n    background-color: #1a202c;\n    padding: 1rem;\n    border-radius: 8px;\n    margin-top: 1rem;\n    color: #ffffff;\n  }\n  \n  .select-box {\n    background-color: #2d3748;\n    border: 1px solid #4a5568;\n    color: #fff;\n    padding: 5px;\n    border-radius: 4px;\n    margin-bottom: 10px;\n  }\n   */\n\n\n   .tab-box-outer.nav-link {\n    border: 1px solid #fff !important;\n    color: #fff !important;\n  }\n  .nav-tabs .nav-link:hover {\n    color: #000 !important;\n  }\n  /* .nav-tabs .nav-link {\n    border-radius: 6px !important;\n  \n} */\n\n\n.nav-tabs .nav-link {\n    color: white;\n    background-color: transparent;\n    border: none;\n    font-weight: 500;\n    padding: 8px 16px;\n    border-radius: 6px !important;\n    border: 1px solid #fff !important;\n\n\n  }\n  \n  .nav-tabs .nav-link.active {\n    background-color: white;\n    color: black;\n    border-radius: 5px;\n  }\n  \n\n\n  .collapse-box {\n    padding: 10px;\n    border: 1px solid #ddd;\n    background: #f9f9f9;\n    margin-top: 10px;\n    color: #000;\n  }\n  \n  .coll-list {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
